import { Marker } from "react-map-gl/maplibre"

import type { Farm } from "../../types/logisticsTypes.ts"

export default function FarmMarker({ farm }: { farm: Farm }) {
  return (
    <Marker longitude={farm.longitude} latitude={farm.latitude}>
      <div className="bg-muted font-sans py-1 px-2 rounded-md text-muted-foreground text-[12pt] shadow-sm border">
        {farm.name}
      </div>
    </Marker>
  )
}
